import Vue from "vue";
import VueRouter from "vue-router";
//TODO: uncomment this
import AuthRequired from "./utils/AuthRequired";
// import path from "vue-i18n/src/path";

Vue.use(VueRouter);

const REQUIRED_BUILD_VERSION = "2026";

const isAndroidTwa = () => {
  const ua = navigator.userAgent || "";
  const isAndroid = /Android/i.test(ua);
  const isStandalone = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
  const isTrustedWebActivityReferrer = document.referrer && document.referrer.startsWith("android-app://");
  const isWebView = /; wv\)/i.test(ua) || /\bwv\b/i.test(ua);

  return isAndroid && (isStandalone || isTrustedWebActivityReferrer || isWebView);
};

const checkBuildVersion = (to, from, next) => {
  const buildVersion = sessionStorage.getItem("pwa_build_version");

  if ((!buildVersion || buildVersion !== REQUIRED_BUILD_VERSION) && isAndroidTwa()) {
    next("/update-required");
    return;
  }

  next();
};

const routes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "application" */ "./views/app"),
    redirect: "/app/home",
    beforeEnter: AuthRequired,
    children: [
      {
        path: "app/document/:id",
        component: () =>
            import(/* webpackChunkName: "home" */ "./views/app/document/DocumentsView.vue"),
        props: true
      },
      {
        path: "app/home",
        beforeEnter: checkBuildVersion,
        component: () =>
          import(/* webpackChunkName: "home" */ "./views/app/acounto/Home"),
      },
      {
        path: "app/home/:timestamp",
        beforeEnter: checkBuildVersion,
        component: () =>
          import(/* webpackChunkName: "home" */ "./views/app/acounto/Home"),
      },
      {
        path: "app/tasks",
        component: () =>
          import(/* webpackChunkName: "home" */ "./views/app/tasks/Tasks"),
      },
      {
        path: "app/tickets",
        component: () =>
          import(/* webpackChunkName: "home" */ "./views/app/tickets/Tickets"),
      },
      {
        path: "app/tickets/:uuid",
        component: () =>
          import(/* webpackChunkName: "home" */ "./views/app/tickets/Ticket"),
      },
      {
        path: "app/task",
        component: () =>
          import(/* webpackChunkName: "home" */ "./views/app/tasks/Task"),
      },
      {
        path: "app/companies",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "./views/app/acounto/Companies"
          ),
      },
      {
        path: "app/company/add",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "./views/app/acounto/NewCompany"
          ),
      },
      {
        path: "app/incomes",
        component: () =>
          import(/* webpackChunkName: "home" */ "./views/app/incomes/Incomes"),
      },
      {
        path: "app/incomes/list",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "./views/app/incomes/IncomeList"
          ),
      },
      {
        path: "app/income/:id",
        component: () =>
          import(/* webpackChunkName: "home" */ "./views/app/incomes/Income"),
      },
      // {
      //   path: "app/incomes/upload",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "home" */ "./views/app/incomes/UploadIncomes"
      //     ),
      // },
      {
        path: "app/incomes/fileUpload",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "./views/app/costs/FileUpload"
          ),
      },
      {
        path: "app/costs",
        component: () =>
          import(/* webpackChunkName: "home" */ "./views/app/costs/Costs"),
      },
      {
        path: "app/costs/list",
        component: () =>
          import(/* webpackChunkName: "home" */ "./views/app/costs/CostList"),
      },
      // {
      //   path: "app/costs/upload",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "home" */ "./views/app/costs/UploadCosts"
      //     ),
      // },
      {
        path: "app/costs/fileUpload",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "./views/app/costs/FileUpload"
          ),
      },
      {
        path: "app/customs/:id",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "./views/app/costs/CustomsView.vue"
          ),
        props: true
      },
      {
        path: "app/cashflow",
        component: () => import(/* webpackChunkName: "home" */ "./views/app/cashflow/CashFlow")
      },
      {
        path: "app/cashflow-detail/:id",
        component: () => import(/* webpackChunkName: "home" */ "./views/app/cashflow/DocumentDetail")
      },
      // {
      //   path: "app/cashflow/upload",
      //   component: () => import(/* webpackChunkName: "home" */ "./views/app/cashflow/UploadCashFlow")
      // },
      {
        path: "app/cashflow/fileUpload",
        component: () => import(/* webpackChunkName: "home" */ "./views/app/costs/FileUpload")
      },
      // {
      //   path: "app/employee/document/upload/:id",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "home" */ "./views/app/wage/NewDocUploadForEmployee.vue"
      //     ),
      // },
      {
        path: "app/employee/list",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "./views/app/wage/Employee.vue"
          ),
      },
      {
        path: "app/employee/create/:companyId/:type",
        component: () => import("./views/app/wage/EditEmployee")
      },
      {
        path: "app/employee/edit/:employeeId/fileUpload",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "./views/app/costs/FileUpload"
          ),
      },
      {
        path: "app/employee/edit/:employeeId",
        component: () => import("./views/app/wage/EditEmployee")
      },
      {
        path: "app/profile",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "./views/app/profile/Profile.vue"
          ),
      },
      {
        path: "app/impersonation",
        component: () =>
            import(
                /* webpackChunkName: "home" */ "./views/app/admin/ImpersonationView.vue"
                ),
      }
    ],
  },
  {
    path: "/error",
    component: () => import(/* webpackChunkName: "error" */ "./views/Error"),
  },
  {
    path: "/login",
    beforeEnter: checkBuildVersion,
    component: () =>
      import(/* webpackChunkName: "user" */ "./views/login/Login"),
  },
  {
    path: "/success-reg",
    beforeEnter: checkBuildVersion,
    component: () =>
      import(/* webpackChunkName: "user" */ "./views/login/Login"),
  },
  {
    path: "/update-required",
    component: () =>
      import(
        /* webpackChunkName: "user" */ "./views/UpdateRequired"
      ),
  },
  {
    path: "/forgotten-password",
    component: () =>
      import(/* webpackChunkName: "user" */ "./views/login/ForgottenPassword"),
  },
  {
    path: "/start",
    component: () => import("./views/register/RegisterExternal"),
  },
  {
    path: "/payment/registration-redirect",
    component: () => import("./views/payment/RegistrationRedirect"),
  },

  // {
  //     path: "/register",
  //     component: () => import(/* webpackChunkName: "user" */ "./views/login/Register"),
  // },
  {
    path: "/reset",
    component: () =>
      import(/* webpackChunkName: "user" */ "./views/login/NewPassword"),
  },

  {
    path: "*",
    component: () => import(/* webpackChunkName: "error" */ "./views/Error"),
  },
];

const router = new VueRouter({
  linkActiveClass: "active",
  routes,
  mode: "history",
});

export default router;
